export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/lsa-photos-0aa6b3e757d3aca603f96510dd859f05.png";